// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3GnQq","productName":"Table_productName__-o5e1"};